import appConfig from "@config/app";
import { prependUri } from "hassibot/services_v2/common";

class LoginRoutes {
  registerDevice = (): string => "hassibot/register-device";
}

export const routes = prependUri(appConfig.API_BASE_URL + "/2/collaborators/")(new LoginRoutes());
